import Store from './Store';
import WidgetClonerStore from './cloner/Store'

export {
    Store,
    WidgetClonerStore
}

export default Store;